(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["core"] = factory(require("axios"));
	else
		root["core"] = factory(root["axios"]);
})(Object(typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__742__) => {
return 